// extracted by mini-css-extract-plugin
export default {"termsError":"TermsConditionsWithdrawals_termsError__IoZwH","buttonText":"TermsConditionsWithdrawals_buttonText__dbx16"};